import _ from "lodash";

export class ModalModule {

    constructor() {
    }

    private DOMElements: any = {
        dataModal: [],
        closeModal: [],
        allModals: [],
    }

    init() {
        this.DOMElements.dataModal = document.querySelectorAll('[data-modal]');
        this.DOMElements.closeModal = document.querySelectorAll('.modal-close');
        this.DOMElements.allModals = document.querySelectorAll('.modal');

        this.handleModal();
    }

    handleModal() {

        [].forEach.call(this.DOMElements.dataModal, el => {

            el.addEventListener('click', () => {
                const clickedElementHasActive = el.classList.contains('active');
                if (innerWidth > 1023) {
                    const modalNumber = el.getAttribute('data-modal');
                    this.showModal(modalNumber)
                } else {
                    this.DOMElements.dataModal.forEach((elem: any) => elem.classList.remove('active'));
                    if (clickedElementHasActive) {
                        el.classList.remove('active');
                    } else {
                        el.classList.toggle('active');
                    }
                }
            })
        });

        [].forEach.call(this.DOMElements.closeModal, el => {
            el.addEventListener('click', () => {
                const modalNumber = el.closest('.modal').getAttribute('data-modal-window');
                this.hideModal(modalNumber);
            })
        });
    }


    hideModal(modalIndex: number) {
        const modal = document.querySelector(`[data-modal-window="${modalIndex}"]`);
        modal!.classList.toggle('hidden');

    }


    showModal(modalIndex: number) {
        const modal = document.querySelector(`[data-modal-window="${modalIndex}"]`);
        modal!.classList.toggle('hidden');
    }
}
